export const RegexConst = {
  TEXT_WITH_SPACE: "^[a-zA-Z ]*$",
  NUMBER: "[0-9]*",
  NUMBER_WITH_DECIMAL: "^\\d*(\\.\\d+)?$",
  ALPHA_NUMERIC_WITH_UNDERSCORE: "^[a-zA-Z0-9_]*$",
  ALPHA_NUMERIC_WITH_DASH: "^[a-zA-Z0-9-]*$",

  EMAIL:
    "^\\s*((?:\\w+(.\\w+)?@[a-zA-Z_]+?(\\.[a-zA-Z]{2,3})(\\.[a-zA-Z]{2,2})?\\b\\s*))+$",
  MOBILE_NUMBER: "^(\\+\\d{1,3}[\\- ]?)?\\d{10}$",
  PHONE_NO: "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$",
  COUNTRY_CODE: "^(\\+?\\d{1,3}|\\d{1,4})$",
  WEBSITE:
    "^(?:http(s)?://)[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&'\\(\\)\\*\\+,;=.]+$",
  ZIP: "^([0-9]{5}|[a-zA-Z][a-zA-Z ]{0,49})$",
  MAIL_ENCODING: "\\d-bit",
  DATE: "([12]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01]))",
  IP_ADDRESS:
    "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$",

  YOUTUBE_URL:
    "^((?:https?:)?\\/\\/)?((?:www|m)\\.)?((?:youtube\\.com|youtu.be))(\\/(?:[\\w\\-]+\\?v=|embed\\/|v\\/)?)([\\w\\-]+)(\\S+)?$",
  ADDRESS: "^[a-zA-Z0-9\\s,\\.\\-/#]+$",
  VALID_STRING: "^[a-zA-Z][a-zA-Z0-9 _\\-.,@#!$%^&*()]*$",
  USERNAME: "^[a-zA-Z][a-zA-Z0-9_-]{2,19}$",
  PASSWORD: "^(?=.*[A-Z])(?=.*[!@#$%^&*()_+\\-={}\\[\\]:\";'<>?,./]).{6,}$",
  NOTE_FIELD:
    "^(?!\\s)(?!.*<[\\s\\S]*>)[a-zA-Z0-9\\s\\-.,?!\"'():;/&%*=+@#$]*$",
};
